import { useCallback, useState } from 'react'

import { post } from '@/services/card/post'

export const useCardPost = () => {
  const [isLoading, setIsLoading] = useState(false)

  const cardPost = useCallback(
    async ({
      id,
      idOperadora,
      idUnidade,
      cpf,
      numeroCartao
    }: {
      id: string
      idOperadora: string
      idUnidade: string
      cpf: string
      numeroCartao: string
    }) => {
      try {
        setIsLoading(true)
        const response = await post({
          id,
          idOperadora,
          idUnidade,
          cpf,
          numeroCartao
        })

        return response
      } catch (error) {
        return error
      } finally {
        setIsLoading(false)
      }
    },
    []
  )

  return { cardPost, isLoading }
}
